import React from 'react';
import '../theme/style.css';
import Navbar from './Navbar';
import { Container } from '@chakra-ui/react';
import Footer from './Footer';

const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <Container fluid paddingInline={'0'}>
      <Navbar />
      {children}
      <Footer />
    </Container>
  );
};

export default Layout;
